<template>
  <div class="onboarding-progress-table">
    <OnboardingProgressCard
      v-for="progress in progresses"
      :key="progress.id || progress.label"
      :progress="progress"
      :disabled="disabled"
      @select="$emit('select', $event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import OnboardingProgressCard from "@/components/Onboarding/OnboardingProgressCard.vue";
import type { OnboardingProgressDisplay } from "@/components/Onboarding/OnboardingProgressDisplay";

export default defineComponent({
  name: "OnboardingProgressTable",
  components: {
    OnboardingProgressCard,
  },
  props: {
    progresses: {
      type: Array as PropType<OnboardingProgressDisplay[]>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    select: (_progress: OnboardingProgressDisplay) => true,
  },
});
</script>

<style scoped>
.onboarding-progress-table {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

@media (max-width: 960px) {
  .onboarding-progress-table {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .onboarding-progress-table {
    grid-template-columns: 1fr;
  }
}
</style>
